import React, { useEffect, useState } from 'react'

import CTA from '@f/elements/CTA'
import Icon from '@f/elements/Icon'
import FormSlider from '@f/elements/FormSlider'
import { getUrl } from '@js/common/getUrlByDomain'

const BudgetCalculatorModal = ({
  mortgageTermYears,
  yearlyInterestRate,
  fixedInterestRatePeriodYears,
  equity,
  extraCosts,
  paymentToPrincipal,
  defaultMonthlyRate,
  closeModal
}) => {
  const [selectedRate, setSelectedRate] = useState(defaultMonthlyRate)
  const [estimatedBudget, setEstimatedBudget] = useState(0)

  const closeOverlay = () => {
    _wt({
      category: 'modal',
      action: 'hide',
      values: [
        {
          type: 'name',
          value: 'budget-calculator'
        }
      ]
    })

    closeModal()
  }

  const getResult = () => {
    /* r */ let monthlyInterestRate = yearlyInterestRate / 12
    /* n */ let mortgageTermMonths = mortgageTermYears * 12
    /* P */ let maxBorrowAmount =
      (((1 + monthlyInterestRate) ** mortgageTermMonths - 1) * selectedRate) /
      (monthlyInterestRate * (1 + monthlyInterestRate) ** mortgageTermMonths)

    /* B */ let houseBudget = maxBorrowAmount / 0.96

    return Math.round(houseBudget / 12500) * 12500
  }

  const handleSliderMove = value => {
    setSelectedRate(value)
  }

  useEffect(() => {
    setEstimatedBudget(getResult())
  }, [selectedRate])

  const handleSliderDrop = value => {
    // Call handleSliderMove to force re-calculation when user clicks without dragging
    handleSliderMove(value)
  }

  let formattedEquity = Number((equity * 100).toFixed(2)).toLocaleString(
    'de-DE'
  )
  let formattedYearlyInterestRate = Number(
    (yearlyInterestRate * 100).toFixed(2)
  ).toLocaleString('de-DE')
  let formattedExtraCosts = Number(
    (extraCosts * 100).toFixed(2)
  ).toLocaleString('de-DE')
  let formattedPaymentToPrincipal = Number(
    (paymentToPrincipal * 100).toFixed(2)
  ).toLocaleString('de-DE')

  useEffect(() => {
    _wt({
      category: 'modal',
      action: 'display',
      values: [
        {
          type: 'name',
          value: 'budget-calculator'
        }
      ]
    })
  }, [])

  return (
    <div className='RequestWizard-wrapper'>
      <div className='RequestWizard'>
        <div className='RequestWizard-form-wrapper'>
          <div className='RequestWizard-top'>
            <div className='RequestWizard-heading'>
              <div className='[ f-t-tmedium f-c-fo-pri f-t-centre f-p-h-080:m ]'>
                Budget-Rechner
              </div>
            </div>

            <div className='RequestWizard-content'>
              <div className='[ f-t-body f-c-fo-pri f-m-h-010 ]'>
                Wunschrate oder Miete
              </div>
              <div className='[ f-t-tsection f-c-fo-pri f-m-h-010 ]'>
                {selectedRate.toLocaleString('de-DE')} €
              </div>
              <FormSlider
                type='Slider'
                value={selectedRate}
                sliderMin={0}
                sliderMax={1600}
                sliderStep={1}
                onChange={handleSliderMove}
                onAfterChange={handleSliderDrop}
              />

              <div className='[ f-t-centre f-m-v-020 f-p-a-020 f-c-ba-whi ]'>
                <div className='[ f-c-fo-pri f-t-mini ]'>Maximales Budget</div>
                <div className='[ f-c-fo-pri f-t-tsection ]'>{`${estimatedBudget.toLocaleString(
                  'de-DE'
                )} €`}</div>
              </div>

              <CTA
                type='block-secondary'
                tag='a'
                data-sel='btn-cta'
                className='[ f-m-h-auto f-m-t-020 ] is-block:s'
                href={getUrl('financeAssistance')()}
                wtData={{
                  'CTA-click': {
                    label: 'finance-quiz-standalone',
                    location: 'modal-budget-calculator'
                  }
                }}>
                Finanzierungsvergleich
              </CTA>
              <CTA
                type='block-primary'
                tag='a'
                className='[ f-m-h-auto f-m-t-020 ] is-block:s'
                data-sel='btn-cta'
                href={`${getUrl(
                  'houseList'
                )()}?price_ready__range=,${estimatedBudget}`}>
                {`Häuser bis ${estimatedBudget.toLocaleString(
                  'de-DE'
                )} € finden`}
              </CTA>
            </div>
          </div>

          <div className='RequestWizard-bottom'>
            <div className='[ f-t-centre f-t-micro f-c-fo-neu200 f-p-v-010 f-m-t-010 f-p-h-080:m ]'>
              {`Diese Berechnung dient als erste Indikation und Orientierung für Ihr Hausbudget und kann Ihre individuelle Situation nicht vollständig abbilden. Sie beruht auf folgenden Annahmen: ${formattedEquity}% Eigenkapital, ${formattedYearlyInterestRate}% Sollzins, ${fixedInterestRatePeriodYears} Jahre Sollzinsbindung, ${formattedPaymentToPrincipal}% Tilgungsrate, ${formattedExtraCosts}% Baunebenkosten, Ausbaustufe Schlüsselfertig)`}
            </div>
          </div>
        </div>
        <CTA
          type='icon'
          tag='button'
          className='Modal-top-button Modal-top-button-close'
          onClick={closeOverlay}
          data-sel='btn-cls'>
          <Icon icon='close-16px' className='[ f-icon-030 f-c-st-bla ]' />
        </CTA>
      </div>
    </div>
  )
}

export default BudgetCalculatorModal
